import { InputHTMLAttributes } from 'react';
import { Check } from 'lucide-react';

type Size = 16 | 20 | 22;

const BOX: Record<Size, string> = {
  16: 'h-4 w-4 rounded-[5px]',
  20: 'h-5 w-5 rounded-[6px]',
  22: 'h-[22px] w-[22px] rounded-[7px]',
};
const TICK: Record<Size, string> = { 16: 'h-[11px] w-[11px]', 20: 'h-3 w-3', 22: 'h-3.5 w-3.5' };

/**
 * Design `.cb`: a rounded square (22px Students, 20px Sections, 16px CP), navy fill and white
 * tick when checked, in both themes. Native input underneath.
 */
export default function Checkbox({ className = '', size = 22, ...rest }: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> & { size?: Size }) {
  return (
    <span className={`relative inline-grid ${BOX[size]} flex-none place-items-center ${className}`}>
      <input
        {...rest}
        type="checkbox"
        className={`peer ${BOX[size]} cursor-pointer appearance-none border-[1.5px] border-control bg-surface transition-colors hover:border-slate checked:border-navy checked:bg-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent`}
      />
      <Check aria-hidden="true" strokeWidth={2.8}
        className={`pointer-events-none absolute ${TICK[size]} text-white opacity-0 peer-checked:opacity-100`} />
    </span>
  );
}
